document.addEventListener("DOMContentLoaded", function () {
  // Star ratings, reviews, see all reviews, faq scroll down (below product title/shorthand title)
  try {
    const judgeMeRatingWidgets = document.querySelectorAll(".jdgm-prev-badge");
    if (judgeMeRatingWidgets.length > 0) {
      judgeMeRatingWidgets.forEach((widget) => {
        try {
          const averageRating = widget.getAttribute("data-average-rating");
          const numberOfReviews = widget.getAttribute("data-number-of-reviews");
          if (!averageRating || !numberOfReviews) {
            console.warn(
              "Missing data-average-rating or data-number-of-reviews attributes for widget:",
              widget
            );
            return;
          }
          const ratingNumber = document.createElement("span");
          ratingNumber.classList.add("rating-number");
          ratingNumber.textContent = parseFloat(averageRating).toFixed(1);
          widget.prepend(ratingNumber);

          const reviewCount = document.createElement("span");
          reviewCount.classList.add("review-count");
          reviewCount.textContent = `(${numberOfReviews})`;
          widget.append(reviewCount);

          const seeAllReviewsLink = document.createElement("a");
          seeAllReviewsLink.href = "#";
          seeAllReviewsLink.textContent = "See all reviews";
          seeAllReviewsLink.classList.add("see-all-reviews");
          seeAllReviewsLink.style.marginLeft = "10px";
          seeAllReviewsLink.onclick = function (e) {
            e.preventDefault();
            try {
              const starsWidget = widget.querySelector(
                ".jdgm-prev-badge__stars"
              );
              if (starsWidget) {
                starsWidget.click();
              }
            } catch (error) {
              console.error(
                "Error handling 'See all reviews' click event:",
                error
              );
            }
          };
          widget.append(seeAllReviewsLink);

          const faqsLink = document.createElement("a");
          faqsLink.href = "#product-faq-section";
          faqsLink.textContent = "FAQs";
          faqsLink.classList.add("faqs-link");
          faqsLink.style.marginLeft = "10px";
          faqsLink.onclick = function (e) {
            e.preventDefault();

            const faqSection = document.getElementById("product-faq-section");
            if (faqSection) {
              faqSection.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
              console.warn("FAQ section not found in DOM.");
            }
          };
          widget.append(faqsLink);
        } catch (error) {
          console.error(
            "Error processing a JudgeMe rating widget:",
            widget,
            error
          );
        }
      });
    }
  } catch (error) {
    console.error(
      "An error occurred in the JudgeMe rating widgets script:",
      error
    );
  }

  // Product description read more
  const pdpContentReadmore = document.getElementById("pdp-content-readmore");
  if (pdpContentReadmore) {
    pdpContentReadmore.onclick = function (event) {
      event.preventDefault();
      try {
        var descriptionFull = document.getElementById(
          "product-description-full"
        );
        var descriptionShort = document.getElementById(
          "product-description-short"
        );
        if (descriptionFull && descriptionShort) {
          descriptionFull.style.display = "block";
          descriptionShort.style.display = "none";
        }
      } catch (error) {
        console.error("An error occurred in 'read more' functionality:", error);
      }
    };
  }

  // Product description read less
  const pdpContentReadless = document.getElementById("pdp-content-readless");
  if (pdpContentReadless) {
    pdpContentReadless.onclick = function (event) {
      event.preventDefault();
      try {
        var descriptionFull = document.getElementById(
          "product-description-full"
        );
        var descriptionShort = document.getElementById(
          "product-description-short"
        );
        if (descriptionFull && descriptionShort) {
          descriptionFull.style.display = "none";
          descriptionShort.style.display = "block";
        }
      } catch (error) {
        console.error("An error occurred in 'read less' functionality:", error);
      }
    };
  }

  // Hero tabs - Recommended Use, Warning, Storage (desktop)
  try {
    var heroTabBtns = document.querySelectorAll(".hero-tab-btn");
    if (heroTabBtns.length > 0) {
      var heroTabContent1 = document.getElementById("hero-tab1-content");
      var heroTabContent2 = document.getElementById("hero-tab2-content");
      var heroTabContent3 = document.getElementById("hero-tab3-content");

      if (heroTabContent1 && heroTabContent2 && heroTabContent3) {
        function openHeroTab(tabIndex) {
          try {
            heroTabContent1.style.display = "none";
            heroTabContent2.style.display = "none";
            heroTabContent3.style.display = "none";

            heroTabBtns.forEach(function (tablink) {
              tablink.classList.remove("active");
            });

            if (tabIndex === 1) {
              heroTabContent1.style.display = "block";
              heroTabBtns[0].classList.add("active");
            } else if (tabIndex === 2) {
              heroTabContent2.style.display = "block";
              heroTabBtns[1].classList.add("active");
            } else if (tabIndex === 3) {
              heroTabContent3.style.display = "block";
              heroTabBtns[2].classList.add("active");
            }
          } catch (error) {
            console.error("Error in openHeroTab function:", error);
          }
        }
        openHeroTab(1);
        heroTabBtns[0].onclick = () => openHeroTab(1);
        heroTabBtns[1].onclick = () => openHeroTab(2);
        heroTabBtns[2].onclick = () => openHeroTab(3);
      }
    }
  } catch (error) {
    console.error("An error occurred in the desktop hero tabs script:", error);
  }

  // Pack size variants
  function selectVariantAndSetPrice(card, index) {
    try {
      const variantInputs = document.querySelectorAll(
        ".variant-picker__option-values input"
      );
      if (variantInputs[index]) {
        variantInputs[index].click();
      }
      const selectedPrice = card.querySelector(".current-price").innerText;
      const currentPriceShowOnADTC = document.getElementById(
        "current-price-show-on-buy-btn"
      );
      if (currentPriceShowOnADTC) {
        document.getElementById("current-price-show-on-buy-btn").innerText =
          selectedPrice;
      }
    } catch (error) {
      console.error("Error in selectVariantAndSetPrice:", error);
    }
  }

  // Function to initialize pricing card selection
  let firstTimePack1Selected = true;
  function initializePricingCards() {
    const pricingCards = document.querySelectorAll(".pricing-card");

    if (pricingCards.length === 0) return;

    if (pricingCards.length === 1) {
      pricingCards[0].onclick = function () {
        selectVariantAndSetPrice(this, 0);
        updateActiveCard(this);
      };
      selectVariantAndSetPrice(pricingCards[0], 0);
      pricingCards[0].classList.add("active");
    } else {
      pricingCards.forEach((card, index) => {
        card.onclick = function () {
          selectVariantAndSetPrice(this, index);
          updateActiveCard(this);

          const content1 = this.getAttribute("data-popup-content1")?.trim();
          const content2 = this.getAttribute("data-popup-content2")?.trim();

          if (index === 0 && firstTimePack1Selected && content1 && content2) {
            openPackPopup(content1, content2);
            firstTimePack1Selected = false;
          }
        };
      });

      // Default to second card (best seller)
      selectVariantAndSetPrice(pricingCards[1], 1);
      pricingCards[1].classList.add("active");
    }
  }

  // Helper function to update active card state
  function updateActiveCard(selectedCard) {
    const pricingCards = document.querySelectorAll(".pricing-card");
    try {
      pricingCards.forEach((card) => card.classList.remove("active"));
      selectedCard.classList.add("active");
    } catch (error) {
      console.error("Error while switching pricing cards: ", error);
    }
  }
  initializePricingCards();

  function openPackPopup(content1, content2) {
    try {
      const overlay = document.getElementById("packOverlay");
      const packPopup = document.getElementById("packPopup");
      const mainPara = document.querySelector(".pack-popup-main-para");
      const subPara = document.querySelector(".pack-popup-sub-para");

      if (!overlay || !mainPara || !subPara) {
        console.error("Popup overlay or required elements not found.");
        return;
      }

      if (!content1 || !content2) {
        console.warn("Popup content not found. Skipping popup display.");
        return;
      }

      mainPara.textContent = content1;
      subPara.textContent = content2;

      overlay.style.display = "flex";
      overlay.setAttribute("aria-hidden", "false");
      packPopup.style.display = "flex";
      document.body.classList.add("no-scroll-while-popup");
    } catch (error) {
      console.error("Error opening popup:", error.message);
    }
  }

  function closePackPopup() {
    try {
      const overlay = document.getElementById("packOverlay");
      if (!overlay) throw new Error("Popup overlay not found");

      const packPopup = document.getElementById("packPopup");
      if (!packPopup) throw new Error("pack Popup not found");

      packPopup.style.display = "none";
      overlay.style.display = "none";
      overlay.setAttribute("aria-hidden", "true");
      document.body.classList.remove("no-scroll-while-popup");
    } catch (error) {
      console.error("Error closing popup:", error.message);
    }
  }

  const closeButton = document.getElementById("closePackPopup");
  if (closeButton) {
    closeButton.onclick = function () {
      closePackPopup();
    };
  }

  const overlayElement = document.getElementById("packOverlay");
  if (overlayElement) {
    overlayElement.onclick = function (event) {
      try {
        if (event.target === this) {
          closePackPopup();
        }
      } catch (error) {
        console.error("Error handling overlay click:", error.message);
      }
    };
  }

  // Choose your servings popup
  function runChooseYourServingsPopupScript() {
    const cYServingsPopup = document.getElementById("cServ-Wpopup");
    if (cYServingsPopup) {
      try {
        const popupOverlay = document.getElementById("cServ-Wpopup-overlay");
        const popupClose = document.getElementById("cServ-Wpopup-close");
        const popupTitle = document.getElementById(
          "choose-the-servings-popup-title"
        );
        const productDetails = document.querySelector(".product-details");

        if (!popupOverlay || !popupClose || !popupTitle || !productDetails) {
          console.warn(
            "One or more elements required for the popup are missing."
          );
          return;
        }

        function closeChooseYourServingsPopup() {
          cYServingsPopup.style.display = "none";
          popupOverlay.style.display = "none";
          document.body.classList.remove("no-scroll-while-popup");
          productDetails.style.zIndex = 0;
        }

        popupClose.onclick = closeChooseYourServingsPopup;
        popupOverlay.onclick = closeChooseYourServingsPopup;

        popupTitle.onclick = function () {
          productDetails.style.zIndex = 9;
          cYServingsPopup.style.display = "block";
          popupOverlay.style.display = "block";
          document.body.classList.add("no-scroll-while-popup");
        };
      } catch (error) {
        console.error(
          "Error in runChooseYourServingsPopupScript script:",
          error
        );
      }
    }
  }
  if (window.innerWidth < 1366) {
    runChooseYourServingsPopupScript();
  }

  // help.decodeage.com iframe
  function setupClickToShowIframe() {
    try {
      const triggerElement = document.getElementById("help-decodeage-section");
      const iframeContainer = document.getElementById("iframeContainer");
      const overlay = document.getElementById("iframeContainer_overlay");
      const closeIframe = document.getElementById("closeIframeContainer");

      if (triggerElement && iframeContainer && overlay) {
        triggerElement.onclick = function () {
          try {
            overlay.style.display = "block";
            iframeContainer.style.display = "block";
            document.body.classList.add("no-scroll-while-popup");
          } catch (error) {
            console.error("Error while showing iframe and overlay:", error);
          }
        };
      }

      if (closeIframe) {
        closeIframe.onclick = function () {
          try {
            closeHelpDecodeAgeIframe();
          } catch (error) {
            console.error(
              "Error while closing iframe container via close button:",
              error
            );
          }
        };
      } else {
        console.warn("Close button not found.");
      }

      if (overlay) {
        overlay.onclick = function () {
          try {
            iframeContainer.style.display = "none";
            overlay.style.display = "none";
            document.body.classList.remove("no-scroll-while-popup");
          } catch (error) {
            console.error(
              "Error while closing iframe via overlay click:",
              error
            );
          }
        };
      }
    } catch (error) {
      console.error("An error occurred in setupClickToShowIframe:", error);
    }
  }

  function closeHelpDecodeAgeIframe() {
    try {
      const iframeContainer = document.getElementById("iframeContainer");
      const overlay = document.getElementById("iframeContainer_overlay");
      if (iframeContainer && overlay) {
        iframeContainer.style.display = "none";
        overlay.style.display = "none";
        document.body.classList.remove("no-scroll-while-popup");
      } else {
        console.warn(
          "Iframe container or overlay not found when attempting to close."
        );
      }
    } catch (error) {
      console.error("Error in closeHelpDecodeAgeIframe function:", error);
    }
  }

  setupClickToShowIframe();

  // adjust key feature widget height
  const debounceKeyFeaturesWidgetHeight = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };
  const adjustKeyFeaturesWidgetHeight = () => {
    try {
      const productGallery = document.querySelector(".product-gallery__media");
      const pdpFeatures = document.querySelector("#pdpFeatures");
      if (productGallery && pdpFeatures && productGallery.offsetHeight > 0) {
        const productGalleryHeight = productGallery.offsetHeight;
        pdpFeatures.style.height = `${productGalleryHeight}px`;
      }
    } catch (error) {
      console.error("Error adjusting key features widget height:", error);
    }
  };

  adjustKeyFeaturesWidgetHeight();
  const debouncedAdjustKeyFeaturesWidgetHeight =
    debounceKeyFeaturesWidgetHeight(adjustKeyFeaturesWidgetHeight, 100);
  window.addEventListener("resize", debouncedAdjustKeyFeaturesWidgetHeight);
});
$(document).ready(function () {
  
  // ==========================================
  // 1. SLICK CAROUSEL INIT (SAFE MODE)
  // ==========================================
  
  // First, find the container on the page using your main jQuery instance
  var $quotesContainer = $(".custom-quotes-container");

  // Only proceed if the container actually exists on this page AND the slick plugin is loaded
  if ($quotesContainer.length > 0 && typeof $.fn.slick === 'function') {
    try {
      $quotesContainer.slick({
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: false,
        nextArrow: false,
      });
    } catch (error) {
      // This only catches internal Slick errors if it tries to run but fails
      console.error("Slick is loaded but failed to initialize:", error);
    }
  }

  // ==========================================
  // 2. GRID POPUP [ Main product section ]
  // ==========================================
  $(".popup-grid-item").on("click", function () {
    var dataContentElement = $(this).find(".popup-item-data-content");
    if (dataContentElement.length) {
      var contentText = dataContentElement.html()?.trim();
      if (contentText) {
        $("#grid-popup-text").html(contentText);
        $("#grid-popup-overlay").fadeIn();
        $(".shopify-section--header").css("z-index", "1");
        document.body.classList.add("no-scroll-while-popup");
      } else {
        console.error("Popup content element is present but empty.");
      }
    } else {
      console.error(
        "Element with the class '.popup-item-data-content' not found in the clicked item."
      );
    }
  });

  $(".grid-popup-close, #grid-popup-overlay").on("click", function (event) {
    if (event.target == this) {
      $(".shopify-section--header").css("z-index", "10");
      $("#grid-popup-overlay").fadeOut();
      document.body.classList.remove("no-scroll-while-popup");
    }
  });

}); // <--- THIS correctly closes the document.ready block



// =======================================================
// START: NEW & IMPROVED HELPER FUNCTIONS
// Price and Category functions have been made more robust.
// =======================================================

function getProductImageSafely() {
  try {
    const imageElement = document.querySelector('.product-gallery__media img, .product__media-item img, .product-image-main img');
    const metaImage = document.querySelector('meta[property="og:image"]');
    return imageElement?.src || metaImage?.content || 'Unknown';
  } catch (e) { return 'Unknown'; }
}

/**
 * UPDATED: Gets data from the currently active pricing card with more robust selectors.
 */
function getActivePricingCardData() {
    const defaultData = {
        price: 'Unknown',
        discount: 'No Discount',
        packInfo: 'Unknown'
    };
    try {
        let activeCard = document.querySelector('.pricing-card.active');
        // If no active card is found, default to the first one
        if (!activeCard) {
          activeCard = document.querySelector('.pricing-card');
        }

        if (activeCard) {
            // Updated price selector with fallbacks
            const priceEl = activeCard.querySelector('.current-price');
            const discountEl = activeCard.querySelector('.discount');
            const packInfoEl = activeCard.querySelector('.pack-info');

            // Fallback to the main Shopify price display if pricing card fails
            let finalPrice = priceEl ? priceEl.innerText.trim() : 'Unknown';
            if (finalPrice === 'Unknown') {
                const mainPriceEl = document.querySelector('.price-item--sale, .price-item--regular, [data-product-price]');
                if (mainPriceEl) {
                    finalPrice = mainPriceEl.innerText.trim();
                }
            }


            return {
                price: finalPrice,
                discount: discountEl ? discountEl.innerText.trim() : 'No Discount',
                packInfo: packInfoEl ? packInfoEl.innerText.trim() : 'Unknown'
            };
        }
        return defaultData;

    } catch (e) {
        console.error("Error reading pricing card data:", e);
        return defaultData;
    }
}


/**
 * UPDATED: Category function with a more common fallback selector.
 */
function getProductCategorySafely() {
  try {
    // Added '.product-meta__category' as a common fallback
    const breadcrumbLink = document.querySelector('.breadcrumbs__link, a[href*="/collections/"]');
    const metaCategory = document.querySelector('.product-meta__category');
    return breadcrumbLink?.innerText.trim() || metaCategory?.innerText.trim() || 'Unknown';
  } catch (e) { return 'Unknown'; }
}

function getProductRatingSafely() {
  try {
    const judgeMeWidget = document.querySelector('.jdgm-prev-badge');
    if (judgeMeWidget) {
      return judgeMeWidget.getAttribute('data-average-rating') || 'Not Rated';
    }
    const shopifyRating = document.querySelector('[itemprop="ratingValue"]');
    return shopifyRating?.textContent.trim() || 'Not Rated';
  } catch (e) { return 'Not Rated'; }
}

// =======================================================
// END: NEW HELPER FUNCTIONS
// =======================================================


// =========================================
// Utility: Get Product Title Safely
// =========================================
function getProductTitle() {
 const titleFromDOM =
  document.querySelector('.product__title')?.innerText ||
  document.querySelector('h1.product-title')?.innerText ||
  document.querySelector('h1')?.innerText;

 const titleFromMetaTag =
  document.querySelector('meta[property="og:title"]')?.content;

 const titleFromWindow = window.meta?.product?.title ||
             window.Shopify?.product?.title;

 const finalTitle =
  titleFromDOM?.trim() ||
  titleFromMetaTag?.trim() ||
  titleFromWindow?.trim() ||
  'Unknown';

 return finalTitle;
}

// =========================================
// WebEngage: Track "Notify Me" Button Click
// =========================================
document.addEventListener("DOMContentLoaded", function () {
 const pollForNotifyButton = setInterval(() => {
  const notifyBtn = document.querySelector('.klaviyo-back-in-stock-btn, button.gw-button-widget');
   
  if (notifyBtn) {
   console.log('[WebEngage Tracker] Notify button found and binding click handler.');
   notifyBtn.removeEventListener('click', handleNotifyClick);
   notifyBtn.addEventListener('click', handleNotifyClick);
   clearInterval(pollForNotifyButton);
  }
 }, 500);

 function handleNotifyClick() {
  const productTitle = getProductTitle();
  const productId = this.getAttribute('data-product-id') || 'Unknown';
  const variantId = this.getAttribute('data-variant-id') || 'Unknown';
  const productHandle = this.getAttribute('data-product-handle') || window.location.pathname.split('/').pop();
  const productName = productHandle.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    
    const activeCardData = getActivePricingCardData();

  console.log('[WebEngage Tracker] Notify Me button clicked:', {
   productTitle, productId, variantId, productHandle
  });

  if (typeof webengage !== 'undefined' && typeof webengage.track === 'function') {
   webengage.track('Notify_Me_Button_Clicked', {
        'product_title': productTitle,
    'product_id': productId,
    'variant_id': variantId,
    'product_handle': productHandle,
    'product_name': productName,
    'page_url': window.location.href,

        'Image': getProductImageSafely(),
        'Discount': activeCardData.discount,
        'Price': activeCardData.price,
        'Total Amount': activeCardData.price,
        'Category Name': getProductCategorySafely(),
        'Rating': getProductRatingSafely(),
        'Selected Pack': activeCardData.packInfo
   });
   console.log('[WebEngage Tracker] Event Notify_Me_Button_Clicked sent.');
  } else {
   console.warn('[WebEngage Tracker] SDK not initialized.');
  }
 }
});
// =========================================
// WebEngage: Detect Notify Me Popup Open
// =========================================

function initializeNotifyMeTracking() {
  // 1. Check if WebEngage is loaded. If not, wait 500ms and try again.
  if (typeof webengage === 'undefined') {
    setTimeout(initializeNotifyMeTracking, 500);
    return;
  }

  // 2. WebEngage is confirmed loaded, now we can safely use it.
  webengage.onReady(function() {
    console.log("WebEngage is ready. MutationObserver is watching for the 'Notify Me' popup.");

    const backInStockModalSelector = '.gw-modal-body';

    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.matches(backInStockModalSelector) || node.querySelector(backInStockModalSelector))) {
              console.log("WebEngage: 'Notify Me' popup detected!");

              // 3. Wrap tracking in a try...catch so missing data doesn't break the site
              try {
                const notifyButton = document.querySelector('button.gw-button-widget');
                if (!notifyButton) {
                  console.warn("WebEngage: Could not find the notify button.");
                  return;
                }

                // Extract data from the button
                const productId = notifyButton.getAttribute('data-product-id');
                const productHandle = notifyButton.getAttribute('data-product-handle');
                const variantId = notifyButton.getAttribute('data-variant-id');
                const productName = productHandle?.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || 'Unknown';
                
                // Safely call custom functions, defaulting to empty values if they don't exist
                const productTitle = typeof getProductTitle === 'function' ? getProductTitle() : 'Unknown';
                const activeCardData = typeof getActivePricingCardData === 'function' ? getActivePricingCardData() : {};
                const productImage = typeof getProductImageSafely === 'function' ? getProductImageSafely() : '';
                const productRating = typeof getProductRatingSafely === 'function' ? getProductRatingSafely() : '';

                // Track the event
                webengage.track('Notify_Me_Popup_Appeared', {
                  'product_id': productId,
                  'product_name': productName,
                  'product_title': productTitle,
                  'variant_id': variantId,
                  'product_handle': productHandle,
                  'url': window.location.href,
                  'Image': productImage,
                  
                  // Use optional chaining (?.) in case activeCardData is missing
                  'Discount': activeCardData?.discount || 0,
                  'Price': activeCardData?.price || 0,
                  'Total Amount': activeCardData?.price || 0,
                  
                  'Rating': productRating,
                  'Selected Pack': activeCardData?.packInfo || ''
                });

                console.log("WebEngage: Event 'Notify_Me_Popup_Appeared' tracked successfully.");
                
                // Disconnect to avoid firing multiple times
                observer.disconnect(); 

              } catch (error) {
                console.error("WebEngage Tracking Error:", error);
              }
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

// Start the initialization process
initializeNotifyMeTracking();


// MAIN: Optimized & Code-Split PDP Enhancements

// (() => {
//   'use strict';

//   // Debounce utility
//   const debounce = (func, delay) => {
//     let timeout;
//     return (...args) => {
//       clearTimeout(timeout);
//       timeout = setTimeout(() => func.apply(this, args), delay);
//     };
//   };

//   // Lazy load script helper
//   const loadScript = (src, async = true, defer = true) => {
//     return new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = src;
//       script.async = async;
//       script.defer = defer;
//       script.onload = resolve;
//       script.onerror = reject;
//       document.head.appendChild(script);
//     });
//   };

//   // =============================================
//   // 1. JudgeMe Widget Enhancements (Runs Immediately)
//   // =============================================
//   const enhanceJudgeMeWidgets = () => {
//     const widgets = document.querySelectorAll(".jdgm-prev-badge");
//     if (!widgets.length) return;

//     widgets.forEach(widget => {
//       try {
//         const avgRating = widget.getAttribute("data-average-rating");
//         const reviewCount = widget.getAttribute("data-number-of-reviews");
//         if (!avgRating || !reviewCount) return;

//         // Rating number
//         const ratingSpan = Object.assign(document.createElement("span"), {
//           className: "rating-number",
//           textContent: parseFloat(avgRating).toFixed(1)
//         });
//         widget.prepend(ratingSpan);

//         // Review count
//         const countSpan = Object.assign(document.createElement("span"), {
//           className: "review-count",
//           textContent: `(${reviewCount})`
//         });
//         widget.append(countSpan);

//         // See All Reviews
//         const seeAll = Object.assign(document.createElement("a"), {
//           href: "#",
//           textContent: "See all reviews",
//           className: "see-all-reviews",
//           style: "margin-left:10px;"
//         });
//         seeAll.onclick = e => {
//           e.preventDefault();
//           widget.querySelector(".jdgm-prev-badge__stars")?.click();
//         };
//         widget.append(seeAll);

//         // FAQs Link
//         const faqLink = Object.assign(document.createElement("a"), {
//           href: "#product-faq-section",
//           textContent: "FAQs",
//           className: "faqs-link",
//           style: "margin-left:10px;"
//         });
//         faqLink.onclick = e => {
//           e.preventDefault();
//           document.getElementById("product-faq-section")?.scrollIntoView({ behavior: "smooth" });
//         };
//         widget.append(faqLink);
//       } catch (err) {
//         console.error("JudgeMe enhancement error:", err);
//       }
//     });
//   };

//   // =============================================
//   // 2. Read More / Read Less
//   // =============================================
//   const initReadMoreLess = () => {
//     const toggle = (showFull) => {
//       const full = document.getElementById("product-description-full");
//       const short = document.getElementById("product-description-short");
//       if (full && short) {
//         full.style.display = showFull ? "block" : "none";
//         short.style.display = showFull ? "none" : "block";
//       }
//     };

//     document.getElementById("pdp-content-readmore")?.addEventListener("click", e => {
//       e.preventDefault();
//       toggle(true);
//     });

//     document.getElementById("pdp-content-readless")?.addEventListener("click", e => {
//       e.preventDefault();
//       toggle(false);
//     });
//   };

//   // =============================================
//   // 3. Hero Tabs (Desktop)
//   // =============================================
//   const initHeroTabs = () => {
//     const btns = document.querySelectorAll(".hero-tab-btn");
//     const contents = [
//       document.getElementById("hero-tab1-content"),
//       document.getElementById("hero-tab2-content"),
//       document.getElementById("hero-tab3-content")
//     ];

//     if (!btns.length || contents.some(c => !c)) return;

//     const openTab = (index) => {
//       contents.forEach((c, i) => {
//         c.style.display = i === index ? "block" : "none";
//         btns[i]?.classList.toggle("active", i === index);
//       });
//     };

//     openTab(0);
//     btns.forEach((btn, i) => btn.onclick = () => openTab(i));
//   };

//   // =============================================
//   // 4. Pricing Cards + Variant Selection
//   // =============================================
//   const initPricingCards = () => {
//     const cards = document.querySelectorAll(".pricing-card");
//     if (!cards.length) return;

//     let firstTimePack1 = true;

//     const selectVariant = (card, index) => {
//       document.querySelectorAll(".variant-picker__option-values input")[index]?.click();

//       const price = card.querySelector(".current-price")?.innerText || "";
//       const priceDisplay = document.getElementById("current-price-show-on-buy-btn");
//       if (priceDisplay) priceDisplay.innerText = price;

//       // Popup for first pack (only once)
//       if (index === 0 && firstTimePack1) {
//         const c1 = card.getAttribute("data-popup-content1")?.trim();
//         const c2 = card.getAttribute("data-popup-content2")?.trim();
//         if (c1 && c2) openPackPopup(c1, c2);
//         firstTimePack1 = false;
//       }
//     };

//     const setActive = (selected) => {
//       cards.forEach(c => c.classList.remove("active"));
//       selected.classList.add("active");
//     };

//     cards.forEach((card, i) => {
//       card.onclick = () => {
//         selectVariant(card, i);
//         setActive(card);
//       };
//     });

//     // Default: best seller (index 1), fallback to 0
//     const defaultIndex = cards.length > 1 ? 1 : 0;
//     selectVariant(cards[defaultIndex], defaultIndex);
//     cards[defaultIndex].classList.add("active");
//   };

//   // Pack Popup
//   const openPackPopup = (main, sub) => {
//     const overlay = document.getElementById("packOverlay");
//     const popup = document.getElementById("packPopup");
//     if (!overlay || !popup) return;

//     document.querySelector(".pack-popup-main-para").textContent = main;
//     document.querySelector(".pack-popup-sub-para").textContent = sub;

//     overlay.style.display = "flex";
//     popup.style.display = "flex";
//     document.body.classList.add("no-scroll-while-popup");
//   };

//   const closePackPopup = () => {
//     const overlay = document.getElementById("packOverlay");
//     if (overlay) {
//       overlay.style.display = "none";
//       document.getElementById("packPopup").style.display = "none";
//       document.body.classList.remove("no-scroll-while-popup");
//     }
//   };

//   document.getElementById("closePackPopup")?.addEventListener("click", closePackPopup);
//   document.getElementById("packOverlay")?.addEventListener("click", e => e.target === e.currentTarget && closePackPopup());

//   // =============================================
//   // 5. Choose Servings Popup (Mobile <1366px)
//   // =============================================
//   const initChooseServingsPopup = () => {
//     if (window.innerWidth >= 1366) return;

//     const popup = document.getElementById("cServ-Wpopup");
//     const overlay = document.getElementById("cServ-Wpopup-overlay");
//     const close = document.getElementById("cServ-Wpopup-close");
//     const title = document.getElementById("choose-the-servings-popup-title");
//     const details = document.querySelector(".product-details");

//     if (!popup || !overlay || !close || !title || !details) return;

//     const closePopup = () => {
//       popup.style.display = overlay.style.display = "none";
//       document.body.classList.remove("no-scroll-while-popup");
//       details.style.zIndex = 0;
//     };

//     title.onclick = () => {
//       details.style.zIndex = 9;
//       popup.style.display = overlay.style.display = "block";
//       document.body.classList.add("no-scroll-while-popup");
//     };

//     close.onclick = overlay.onclick = closePopup;
//   };

//   // =============================================
//   // 6. Help DecodeAge Iframe
//   // =============================================
//   const initDecodeAgeIframe = () => {
//     const trigger = document.getElementById("help-decodeage-section");
//     const container = document.getElementById("iframeContainer");
//     const overlay = document.getElementById("iframeContainer_overlay");
//     const close = document.getElementById("closeIframeContainer");

//     if (!trigger || !container || !overlay) return;

//     trigger.onclick = () => {
//       overlay.style.display = container.style.display = "block";
//       document.body.classList.add("no-scroll-while-popup");
//     };

//     close && (close.onclick = () => {
//       container.style.display = overlay.style.display = "none";
//       document.body.classList.remove("no-scroll-while-popup");
//     });

//     overlay.onclick = () => {
//       container.style.display = overlay.style.display = "none";
//       document.body.classList.remove("no-scroll-while-popup");
//     };
//   };

//   // =============================================
//   // 7. Key Features Height Match (Debounced)
//   // =============================================
//   const adjustKeyFeaturesHeight = () => {
//     const gallery = document.querySelector(".product-gallery__media");
//     const features = document.getElementById("pdpFeatures");
//     if (gallery && features && gallery.offsetHeight > 0) {
//       features.style.height = `${gallery.offsetHeight}px`;
//     }
//   };

//   const debouncedAdjust = debounce(adjustKeyFeaturesHeight, 100);
//   window.addEventListener("resize", debouncedAdjust);

//   // =============================================
//   // 8. Lazy Load Slick Carousel (Only if element exists)
//   // =============================================
//   const initSlickCarousel = async () => {
//     if (!document.querySelector(".custom-quotes-container")) return;

//     try {
//       await loadScript("https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js");
//       await loadScript("https://code.jquery.com/jquery-3.6.0.min.js"); // if not already loaded

//       $(".custom-quotes-container").slick({
//         dots: false,
//         infinite: true,
//         autoplay: true,
//         autoplaySpeed: 4000,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false
//       });
//     } catch (err) {
//       console.error("Slick load failed:", err);
//     }
//   };

//   // =============================================
//   // 9. Grid Popup (jQuery-based, lazy)
//   // =============================================
//   const initGridPopup = async () => {
//     if (!document.querySelector(".popup-grid-item")) return;

//     await loadScript("https://code.jquery.com/jquery-3.6.0.min.js");

//     $(document).on("click", ".popup-grid-item", function () {
//       const content = $(this).find(".popup-item-data-content").html()?.trim();
//       if (content) {
//         $("#grid-popup-text").html(content);
//         $("#grid-popup-overlay").fadeIn();
//         $(".shopify-section--header").css("z-index", "1");
//         document.body.classList.add("no-scroll-while-popup");
//       }
//     });

//     $(document).on("click", ".grid-popup-close, #grid-popup-overlay", function (e) {
//       if (e.target === this || $(e.target).hasClass("grid-popup-close")) {
//         $("#grid-popup-overlay").fadeOut();
//         $(".shopify-section--header").css("z-index", "10");
//         document.body.classList.remove("no-scroll-while-popup");
//       }
//     });
//   };

//   // =============================================
//   // 10. WebEngage Tracking (Lazy + Safe)
//   // =============================================
//   const initWebEngageTracking = () => {
//     if (typeof webengage === "undefined") return;

//     // Helper functions (same as before, but compact)
//     const getProductTitle = () => document.querySelector('.product__title, h1')?.innerText.trim() || "Unknown";
//     const getProductImageSafely = () => document.querySelector('.product-gallery__media img')?.src || "Unknown";
//     const getActivePricingCardData = () => {
//       const card = document.querySelector('.pricing-card.active') || document.querySelector('.pricing-card');
//       if (!card) return { price: "Unknown", discount: "No Discount", packInfo: "Unknown" };
//       return {
//         price: card.querySelector(".current-price")?.innerText.trim() || "Unknown",
//         discount: card.querySelector(".discount")?.innerText.trim() || "No Discount",
//         packInfo: card.querySelector(".pack-info")?.innerText.trim() || "Unknown"
//       };
//     };

//     // Notify Me Button Click
//     const pollNotifyButton = setInterval(() => {
//       const btn = document.querySelector('.klaviyo-back-in-stock-btn, button.gw-button-widget');
//       if (btn) {
//         btn.addEventListener("click", () => {
//           const data = getActivePricingCardData();
//           webengage.track('Notify_Me_Button_Clicked', {
//             product_title: getProductTitle(),
//             product_id: btn.dataset.productId || "Unknown",
//             variant_id: btn.dataset.variantId || "Unknown",
//             Image: getProductImageSafely(),
//             Price: data.price,
//             Discount: data.discount,
//             'Selected Pack': data.packInfo
//           });
//         });
//         clearInterval(pollNotifyButton);
//       }
//     }, 500);

//     // Notify Me Popup Appear
//     webengage.onReady(() => {
//       new MutationObserver((mutations) => {
//         if ([...mutations].some(m => [...m.addedNodes].some(n => n.matches?.('.gw-modal-body')))) {
//           const btn = document.querySelector('button.gw-button-widget');
//           if (btn) {
//             webengage.track('Notify_Me_Popup_Appeared', {
//               product_title: getProductTitle(),
//               product_id: btn.dataset.productId,
//               Image: getProductImageSafely(),
//               Price: getActivePricingCardData().price
//             });
//             this.disconnect();
//           }
//         }
//       }).observe(document.body, { childList: true, subtree: true });
//     });
//   };

//   // =============================================
//   // Execute on DOM Ready
//   // =============================================
//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", () => {
//       enhanceJudgeMeWidgets();
//       initReadMoreLess();
//       initHeroTabs();
//       initPricingCards();
//       initChooseServingsPopup();
//       initDecodeAgeIframe();
//       adjustKeyFeaturesHeight();

//       // Lazy-load heavy features
//       initSlickCarousel();
//       initGridPopup();
//       initWebEngageTracking();
//     });
//   } else {
//     // Already ready (for turbo/page cache)
//     enhanceJudgeMeWidgets();
//     initReadMoreLess();
//     initHeroTabs();
//     initPricingCards();
//     initChooseServingsPopup();
//     initDecodeAgeIframe();
//     adjustKeyFeaturesHeight();
//     initSlickCarousel();
//     initGridPopup();
//     initWebEngageTracking();
//   }

//   // Run height adjust on load too
//   window.addEventListener("load", adjustKeyFeaturesHeight);
// })();
